import SFullPage from './style.module.scss';
import { Button } from 'antd';
import { src } from '../../../utils/common';
import FadeIn from '../fadeIn';
import { useRef, useEffect } from 'react';
import { useUserAgentInfo } from '../../../context/user-agent';
import Link from 'next/link';
import { WebPNativeImage } from '../../WebPImage';

export const ButtonGroup = ({ data }) => {
  return (
    <div className={SFullPage['btn-group']}>
      <Button type="primary" className={SFullPage['button']}>
        <Link href={data.businessLink} passHref>
          {data.buttonText}
        </Link>
      </Button>
      {data.linkText && (
        <Button type="link" className={SFullPage['button-link']}>
          {data.experienceLink && (
            <Link href={data.experienceLink} passHref>
              {data.linkText}
            </Link>
          )}
        </Button>
      )}
    </div>
  );
};

const FullPageBanner = ({ data }) => {
  const { isMobile } = useUserAgentInfo();
  const ref = useRef(null);
  useEffect(() => {
    const dom = ref.current;
    dom.classList.add(SFullPage['scale']);
  }, []);
  return (
    <div className={SFullPage['section']}>
      <WebPNativeImage
        src={src(isMobile ? data.backgroundImgMobile : data.backgroundImg)}
        alt={data.title}
        ref={ref}
      />
      {/* `${SFullPage['section']} ${SFullPage[isMobile ? mobilePosition : position]}` */}
      <div className={SFullPage['content']}>
        <FadeIn>
          <div
            className={`${SFullPage['container']} ${
              SFullPage[data.type === 'v10' && 'top']
            }`}
          >
            {data.name ? (
              <>
                <div className={SFullPage['name']}>{data.name}</div>
                <div className={SFullPage['slogan']}>{data.slogan}</div>
                <div className={SFullPage['title']}>{data.title}</div>
              </>
            ) : (
              <>
                <div className={SFullPage['title']}>{data.title}</div>
                <div className={SFullPage['slogan']}>{data.slogan}</div>
              </>
            )}
            {data.description && (
              <div className={SFullPage['description']}>
                {data.description.map((item, index) => (
                  <>
                    <div className={SFullPage['description-item']}>
                      <div className={SFullPage['item-title']}>
                        {item.title}
                      </div>
                      <div className={SFullPage['item-desc']}>{item.desc}</div>
                    </div>
                    {index !== data.description.length - 1 && (
                      <div className={SFullPage['divider']} />
                    )}
                  </>
                ))}
              </div>
            )}
          </div>
          {!isMobile && <ButtonGroup data={data} />}
        </FadeIn>
      </div>
    </div>
  );
};

export default FullPageBanner;
